<c-container>
  <c-row>
    <c-col>
      @if (allCharities.length > 0) {
        <div class="margin-bottom-med view-label">Please choose charity you would like take players from:</div>
        <form>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Origin Charity</mat-label>
            <input type="text" matInput [formControl]="chosenOriginCharityControl" [matAutocomplete]="autoOrigin">
            <button mat-icon-button *ngIf="chosenOriginCharityControl.value"
                    matSuffix
                    aria-label="Clear" (click)="clearOriginCharity()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoOrigin="matAutocomplete" [displayWith]="displayFn">
              @for (option of filteredOriginCharities | async; track option) {
                <mat-option [value]="option">{{ option.Name }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-slide-toggle class="margin-bottom-med" [formControl]="deactivateOriginCharityControl">
            Deactivate original charity after moving pledges?
          </mat-slide-toggle>
        </form>

        <div class="view-label">Now choose charity you would like to move the players to:</div>
        <div class="margin-bottom-med">
          <small>*Note: Charity does not exist yet? Please click the Add charities button above and create your
            destination charity before continuing</small>
        </div>
        <form>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Destination Charity</mat-label>
            <input type="text" matInput [formControl]="chosenDestinationCharityControl"
                   [matAutocomplete]="autoDestination">
            <button mat-icon-button *ngIf="chosenDestinationCharityControl.value"
                    matSuffix
                    aria-label="Clear" (click)="clearDestinationCharity()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoDestination="matAutocomplete" [displayWith]="displayFn">
              @for (option of filteredDestinationCharities | async; track option) {
                <mat-option [value]="option">{{ option.Name }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </form>

        @if (chosenDestinationCharityControl.getRawValue() != null &&
        chosenOriginCharityControl.getRawValue() != null &&
        !sameCharitySelected) {
          <c-row>
            <c-col>
              <div class="margin-top-med margin-bottom-med">**Note: <span class="bold-text">{{chosenOriginCharityControl.getRawValue()?.Name}} </span>
              @if(deactivateOriginCharityControl.getRawValue()) {
                will be deactivated and players will no longer be able to choose it as a valid charity to pledge to.
              }@else {
                will remain active and players will still be able to pledge to it.
              }
              </div>
              <button mat-raised-button
                      color="primary"
                      class="full-width"
                      data-testid="add-charities-button"
                      (click)="confirmAndSubmitPledgeUpdates()">
                <mat-icon class="enable-sort">check</mat-icon>
                Confirm and Submit Pledge Updates
              </button>
            </c-col>
          </c-row>
        } @else if (sameCharitySelected) {
          <div class="text-danger margin-top-sm">Origin and Destination charities must be different.</div>
        }
      } @else {
        <div>Looks like there was an issue retrieving your charities.</div>
      }
    </c-col>

  </c-row>

</c-container>
